// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9d33dfdf","49":"7abc6288","58":"2543ba88","214":"c690ec84","418":"aa995a70","607":"3c826a22","759":"f71fef01","807":"1560c61d","843":"cc2dd77e","958":"9bf837c8"}[chunkId] + ".chunk.js";
};